import React from 'react'

import { withFormContext } from '../../../lib/form-context'
import { withDiscardDialog } from '../../../lib/global-discard-dialog'
import { Button } from '../NarusMaterial'

@withFormContext
@withDiscardDialog
export class CancelButton extends React.Component {
  render () {
    const { onClick, label, disabled, long, noGlobal, discardDialog, formKey } = this.props

    let handleClick = noGlobal
      ? onClick
      : () => {
        discardDialog.show(formKey, onClick)
      }

    return (
      <Button
        grey
        label={label}
        long={long}
        disabled={disabled}
        onClick={handleClick}
      />
    )
  }
}

CancelButton.defaultProps = {
  label: 'CANCEL',
  disabled: false,
  long: false,
  noGlobal: false
}
